var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "betslip-page",
      class: [
        _vm.currentBetSlipStateName,
        { "betslip-empty": !_vm.betsNo },
        {
          bet_placed_sucessfuly:
            _vm.betSlipStatus.State == 2 &&
            _vm.activeBetSlipHistoryTab !== "active" &&
            _vm.activeBetSlipHistoryTab !== "settled"
        },
        { fixedBetslip: !_vm.mobileBigAndBelow && _vm.stickyBetslip },
        { betslip_layout_2: _vm.betslipLayout2 }
      ],
      style: [
        !_vm.mobileBigAndBelow && _vm.stickyBetslip ? _vm.betslipHeight() : ""
      ],
      on: {
        click: function($event) {
          return _vm.userIsActive()
        }
      }
    },
    [
      _vm.brandTemplate !== "generic_2" &&
      _vm.isLoggedIn &&
      _vm.mobileBigAndBelow &&
      _vm.betSlipStatus.State != 2
        ? _c(
            "div",
            { staticClass: "preheader" },
            [
              _c("div", { staticClass: "betslip_balance" }, [
                _c("span", { staticClass: "span_balance" }, [
                  _vm._v(_vm._s(_vm.$t("BetSlipPage.tab.balance")))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.balanceSum)))
                ])
              ]),
              _vm._v(" "),
              _vm.mobileBigAndBelow &&
              _vm.isLoggedIn &&
              _vm.brandTemplate !== "generic_2"
                ? _c(
                    "v-btn",
                    {
                      staticClass: "close",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.closeBetslipDialog()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.mobileBigAndBelow ||
      (_vm.mobileBigAndBelow && _vm.betSlipStatus.State != 2) ||
      (_vm.betSlipStatus.State == 2 &&
        (_vm.activeBetSlipHistoryTab === "active" ||
          _vm.activeBetSlipHistoryTab === "settled"))
        ? _c(
            "div",
            {
              staticClass: "betslip-page-header",
              class: [
                { user_logged_in: _vm.isLoggedIn },
                {
                  withBackToBetslip:
                    (_vm.brandLayout === "generic" &&
                      _vm.betslipLayout2 &&
                      _vm.betTypeTab !== "REGULAR") ||
                    (_vm.brandTemplate === "generic_2" && _vm.mobileBigAndBelow)
                }
              ]
            },
            [
              _vm.mobileBigAndBelow
                ? _c(
                    "span",
                    {
                      staticClass: "tab",
                      class: {
                        active:
                          _vm.brandTemplate === "generic_2" ||
                          (_vm.activeBetSlipHistoryTab !== "active" &&
                            _vm.activeBetSlipHistoryTab !== "settled"),
                        disabled: true
                      }
                    },
                    [
                      !_vm.betslipLayout2
                        ? _c(
                            "a",
                            {
                              staticClass: "a-link-",
                              on: {
                                click: function($event) {
                                  return _vm.setTab("BetSlip")
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("BetSlipPage.tab.BetSlip")) +
                                    " "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.brandKey !== "qcasino"
                                ? _c("badge", [_vm._v(_vm._s(_vm.betsNo))])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.brandKey === "qcasino"
                                ? _c("badge", [
                                    _vm._v(_vm._s("(" + _vm.betsNo + ")"))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.betslipLayout2 && _vm.brandLayout === "generic"
                        ? _c(
                            "a",
                            {
                              staticClass: "a-link-",
                              on: {
                                click: function($event) {
                                  return _vm.setTab("BetSlip")
                                }
                              }
                            },
                            [
                              _c("badge", [_vm._v(_vm._s(_vm.betsNo))]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("BetSlipPage.tab.BetSlip")) +
                                    "\n           "
                                ),
                                _vm.brandTemplate === "generic_2" &&
                                _vm.isLoggedIn
                                  ? _c(
                                      "div",
                                      { staticClass: "betslip_balance" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "span_balance" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "BetSlipPage.tab.balance"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "value" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("currency")(_vm.balanceSum)
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileBigAndBelow &&
              _vm.brandLayout === "generic" &&
              _vm.betslipLayout2 &&
              _vm.betTypeTab !== "REGULAR"
                ? _c(
                    "span",
                    { staticClass: "back_to_betslip back-to-betslip" },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.setBetTypeTab("REGULAR")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("BetSlip.tab.label.back")))]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileBigAndBelow &&
              _vm.brandTemplate === "generic_2" &&
              _vm.betslipLayout2
                ? _c("span", {
                    staticClass: "betslip_down_icon",
                    on: {
                      click: function($event) {
                        return _vm.closeBetslipDialog()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.mobileBigAndBelow &&
              _vm.brandTemplate === "generic_2" &&
              _vm.betslipLayout2 &&
              _vm.betTypeTab === "REGULAR"
                ? _c(
                    "span",
                    { staticClass: "back_to_betslip back-to-betslip" },
                    [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.closeBetslipDialog()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("BetSlip.tab.label.close")))]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.brandTemplate !== "generic_2" &&
              _vm.showHistoryTabs === true &&
              _vm.isLoggedIn &&
              _vm.mobileBigAndBelow &&
              (!_vm.betslipLayout2 ||
                (_vm.betslipLayout2 && _vm.betTypeTab === "REGULAR"))
                ? [
                    _c(
                      "span",
                      {
                        staticClass: "tab history-tab",
                        class: {
                          active: _vm.activeBetSlipHistoryTab === "active"
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "a-link-",
                            on: {
                              click: function($event) {
                                return _vm.setTab("HistoryActive")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("BetSlipPage.tab.History.active"))
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "tab history-tab",
                        class: {
                          active: _vm.activeBetSlipHistoryTab === "settled"
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "a-link-",
                            on: {
                              click: function($event) {
                                return _vm.setTab("HistorySettled")
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("BetSlipPage.tab.History.settled")
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.betSlipStatus.State == 2 &&
      _vm.mobileBigAndBelow &&
      _vm.activeBetSlipHistoryTab !== "active" &&
      _vm.activeBetSlipHistoryTab !== "settled"
        ? _c(
            "div",
            { staticClass: "betslip-page-header" },
            [
              _c("span", { key: "your_receipt", staticClass: "your_receipt" }, [
                _vm._v(_vm._s(_vm.$t("BetSlip.status.placed.YourReceipt")))
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "close",
                  attrs: { flat: "" },
                  on: {
                    click: function($event) {
                      return _vm.closeBetslipDialog()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabletAndAbove && _vm.stickyBetslip
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "bar",
                  rawName: "v-bar",
                  value: {
                    preventParentScroll: true,
                    useScrollbarPseudo: true,
                    scrollThrottle: 30
                  },
                  expression:
                    "{preventParentScroll: true, useScrollbarPseudo: true, scrollThrottle: 30}"
                }
              ],
              staticClass: "betslip_scroll",
              style: _vm.vBarHeight()
            },
            [
              _c(
                "div",
                { staticClass: "betslipHolder" },
                [
                  _vm.activeBetSlipHistoryTab !== "active" &&
                  _vm.activeBetSlipHistoryTab !== "settled"
                    ? _c("betslip", { on: { setTabFromBetSlip: _vm.setTab } })
                    : _vm.activeBetSlipHistoryTab === "active"
                    ? _c("statement", { attrs: { selectedState: "Open" } })
                    : _vm.activeBetSlipHistoryTab === "settled"
                    ? _c("statement", { attrs: { selectedState: "NonOpen" } })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabletAndAbove && !_vm.stickyBetslip
        ? _c("div", [
            _c(
              "div",
              { staticClass: "betslipHolder" },
              [
                _vm.activeBetSlipHistoryTab !== "active" &&
                _vm.activeBetSlipHistoryTab !== "settled"
                  ? _c("betslip", { on: { setTabFromBetSlip: _vm.setTab } })
                  : _vm.activeBetSlipHistoryTab === "active"
                  ? _c("statement", { attrs: { selectedState: "Open" } })
                  : _vm.activeBetSlipHistoryTab === "settled"
                  ? _c("statement", { attrs: { selectedState: "NonOpen" } })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.tabletAndAbove
        ? _c(
            "div",
            {
              staticClass: "mobile_betslip",
              class: {
                with_favorites:
                  _vm.playerFavorites &&
                  _vm.favoriteCandidates &&
                  _vm.favoriteCandidates.length > 0
              },
              attrs: { id: "mob_betslip_container" }
            },
            [
              _vm.activeBetSlipHistoryTab !== "active" &&
              _vm.activeBetSlipHistoryTab !== "settled"
                ? _c("betslip", { on: { setTabFromBetSlip: _vm.setTab } })
                : _vm.activeBetSlipHistoryTab === "active"
                ? _c("statement", { attrs: { selectedState: "Open" } })
                : _vm.activeBetSlipHistoryTab === "settled"
                ? _c("statement", { attrs: { selectedState: "NonOpen" } })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-betslip-msg",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.dialogBetslipMsg.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogBetslipMsg, "active", $$v)
            },
            expression: "dialogBetslipMsg.active"
          }
        },
        [
          _c("betslip-msg", {
            attrs: { dialogBetslipMsg: _vm.dialogBetslipMsg }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog-wishbet",
            persistent: "",
            fullscreen: false
          },
          model: {
            value: _vm.dialogWishBetMsg.active,
            callback: function($$v) {
              _vm.$set(_vm.dialogWishBetMsg, "active", $$v)
            },
            expression: "dialogWishBetMsg.active"
          }
        },
        [_c("wish-bet-msg-dialog")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03e5b2c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03e5b2c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/betslipPage.vue
// module id = null
// module chunks = 